import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isTaskModalIsOpen: false,
    isTaskIsUpdated: 0,
    tasks: {}, // Core Backend Task Obj
    stepObj: null, // workflow step obj: step and task are same they both represent the same task resource, AI orchestrator uses step and Core Backend uses task. The obj format will be different for both  but the information is same. 

};

const TaskSlice = createSlice({
    name: "task",
    initialState,
    reducers: {
        // Add or update tasks in the state
        setTask: (state, action) => {
            const task = action.payload; // Assuming payload is the full task object
            state.tasks = task;
            // return {...state, tasks: action.payload}

        },

        // Clear all tasks
        clearTask: (state) => {
            state.tasks = {}; // Clear the tasks object
        },

        // Toggle the task modal
        toggleModal: (state) => {
            //state.isTaskModalIsOpen = !state.isTaskModalIsOpen;
            return { ...state, isTaskModalIsOpen: !state.isTaskModalIsOpen }
        },
        taskUpdated: (state) => {
            state.isTaskIsUpdated += 1; 
        },


        // Replace the entire comments array and push new comments into the array
        updateComments: (state, action) => {
            return {
                ...state, // Spread the entire state to maintain other properties
                tasks: {
                    ...state.tasks, // Spread the tasks to maintain other properties of tasks
                    included: {
                        ...state.tasks.included, // Spread the included object to preserve other properties
                        comments: [
                            ...state.tasks.included.comments, // Spread the existing comments
                            action.payload // Add the new comment from the action payload
                        ]
                    }
                }
            };
        },

        setStepObj: (state, action) => {
            return {...state, stepObj: action.payload}
        }


    },
});

// Exporting the actions and reducer
export const {
    setTask,
    clearTask,
    toggleModal,
    addComment,
    updateComments,
    updateTaskAttributes,
    taskUpdated,
    setStepObj
} = TaskSlice.actions;

export default TaskSlice.reducer;
